import type { StepRenderProps } from "./types";
import type { TextAreaStep as TextAreaStepConfig } from "@/types/offer";

export function TextAreaStep({
  step,
  value,
  onChange,
  autoFocus,
  error,
}: StepRenderProps<TextAreaStepConfig>) {
  return (
    <textarea
      className="r1-field resize-y"
      rows={step.rows ?? 4}
      autoFocus={autoFocus}
      placeholder={step.placeholder}
      value={typeof value === "string" ? value : ""}
      onChange={(e) => onChange(e.target.value)}
      aria-invalid={!!error}
      aria-label={step.title}
    />
  );
}
